exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons[data-v-5fe32793]{margin-top:16px;text-align:right}", ""]);

// exports
